import { Expose } from "class-transformer";

export class UpdateInterventionDto {
  @Expose()
  id: string;

  @Expose()
  code: string;

  @Expose()
  name: string;

  @Expose()
  activityId: string;
}
